<div
  [formGroup]="parentForm"
  [ngClass]="[
    'input-group-location',
    geoService.language,
    isNewBlueDesign ? 'new-blue-design' : '',
  ]"
>
  @for (field of geoService.formFields; track field) {
    <div [class]="'input-field ' + field.fieldClass">
      <div class="input__icon-wrapper">
        @if (!isReadOnly(field)) {
          <input
            name="postCode"
            type="text"
            [name]="field.name"
            [formControlName]="field.name"
            [placeholder]="field.placeholder | translate"
            [class]="'input-text data-hj-allow ' + field.class"
            (keyup)="onKeyUp.next($event)"
            (paste)="updateFields()"
            required=""
          />
        }
        @if (isReadOnly(field)) {
          <input
            name="postCode"
            type="text"
            [name]="field.name"
            [formControlName]="field.name"
            [placeholder]="field.placeholder | translate"
            [class]="'input-text data-hj-allow ' + field.class"
            required=""
            [disabled]="true"
            [readonly]="true"
          />
        }
      </div>
      <app-input-error
        [element]="parentForm.get(field.name)"
        [type]="field.name"
      ></app-input-error>
    </div>
  }
  <label
    class="input-message input-group-location__error-message"
    [ngClass]="{ visible: geoService.showGroupMessage }"
  >
    @if (geoService.addressAjax && !geoService.addressAjax.closed) {
      <span>
        <i class="fa fa-spinner fa-spin"></i>
      </span>
    }
    {{ "texts.InputGroupLocationComponent_error" | translate }}
  </label>
  <label
    class="input-message input-group-location__error-message"
    [ngClass]="{ visible: geoService.showInvalidMessage }"
  >
    @if (geoService.addressAjax && !geoService.addressAjax.closed) {
      <span>
        <i class="fa fa-spinner fa-spin"></i>
      </span>
    }
    {{ "texts.Modal_register_student_cant_find_address" | translate }}
  </label>
</div>
